import React, { type ComponentType } from 'react';
import CommonFlag from '@atlassian/jira-flags/src/common/ui/components/common-flag';
import type { FlagComponentProps } from '@atlassian/jira-flags/src/services/types';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { messages } from './messages.tsx';

export const AvatarFetchFailedFlag: ComponentType<FlagComponentProps> = injectIntl(
	// @ts-expect-error - Property 'formatMessage' does not exist on type 'IntlShapeV2 | IntlShape | undefined'.
	({ intl: { formatMessage }, ...props }: FlagComponentProps) => (
		<CommonFlag
			{...props}
			flagType="error"
			title={formatMessage(messages.fetchFailedFlagTitle, {})}
			description={formatMessage(messages.fetchFailedFlagDescription, {})}
			messageId={`project-settings-apps-common.avatar-service.common-flag.fetchFailedFlag.${props.id}`}
			messageType="transactional"
		/>
	),
);

export const AvatarUploadFailedFlag: ComponentType<FlagComponentProps> = injectIntl(
	// @ts-expect-error - Property 'formatMessage' does not exist on type 'IntlShapeV2 | IntlShape | undefined'.
	({ intl: { formatMessage }, ...props }: FlagComponentProps) => (
		<CommonFlag
			{...props}
			flagType="error"
			title={formatMessage(messages.uploadFailedFlagTitle, {})}
			description={formatMessage(messages.uploadFailedFlagDescription, {})}
			messageId={`project-settings-apps-common.avatar-service.common-flag.uploadFailedFlag.${props.id}`}
			messageType="transactional"
		/>
	),
);
